import { render, staticRenderFns } from "./PRF103M02.vue?vue&type=template&id=229b4d4a&"
import script from "./PRF103M02.vue?vue&type=script&lang=js&"
export * from "./PRF103M02.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports